import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

import cardShadow from '../../Styles/cardShadow';

export default StyleSheet.create({
  cardContainerStyle: theme => ({
    paddingBottom: 16,
    width: 250,
    marginBottom: 18,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6.3,
    ...cardShadow,
  }),
  image: icon => ({
    padding: 16.7,
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: icon ? 158 : 91.7,
  }),
  imageStyle: {
    borderTopRightRadius: 6.3,
    borderTopLeftRadius: 6.3,
  },
  badgeTextStyle: {
    fontSize: 14.6,
    lineHeight: 18.8,
    paddingHorizontal: 3,
    paddingVertical: 3,
    ...Fonts.type.bold,
  },
  badgeStyle: { alignSelf: 'flex-start', paddingBottom: 0, paddingTop: 2 },
  badgeContainerStyle: { flex: 1 },
  floatingIconStyle: { borderRadius: 5 },
  titleSubtitleContainer: {
    marginTop: 17,
    flex: 1,
    justifyContent: 'space-between',
    marginHorizontal: 16.7,
  },
  upperSectionContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  titleStyle: {
    color: Colors.brownGrey,
    fontSize: 14,
    marginBottom: 0,
  },
  subtitleStyle: {
    flex: 1,
    fontSize: 16,
    ...Fonts.type.bold,
  },
  textStyle: {
    marginBottom: 4.2,
    lineHeight: 22.9,
  },
  footerTextStyle: {
    fontSize: 14.6,
    lineHeight: 18.8,
    color: Colors.secondary7,
    paddingTop: 1,
  },
  footerBtn: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: 2,
  },
});
